export default __webpack_public_path__ + "static/media/waranties.4bfac3ad.svg";